import { observable, action, toJS, extendObservable, computed} from "mobx"
import store from "store"
import _ from "lodash"
import shop from "shop/shop"
import { observer } from "mobx-react";

class SettingStore {

  @computed get orderMode() {
    return this.byName.get("orderMode")
  }

  @observable byName = new Map()

  constructor() {
    this.load()
    // init order mode

    let orderMode = this.get( "orderMode" ) || "NOT_CHOSEN"
    this.set( "orderMode", orderMode )
  }

  load() {
    try {
      let textData = store.get( "settings" )
      if ( !textData ) return

      const data = JSON.parse( textData )
      _.map( data, ( item, key ) => {
        this.byName.set( key, item )
      } )
      this.byName.merge( data )
    } catch ( err ) {
      store.remove( "settings" )
      console.warn( "Could not restore settings from localStorage" )
      this.byName = new Map()
    }
  }

  get( key ) {
    return this.byName.get( key )
  }

  @action
  set( key, value ) {
    this.byName.set( key, value )
    this.save()
    shop && shop.cart && shop.cart.setExtra( key, value )
  }

  save() {
    const json = JSON.stringify( toJS( this.byName ) );
    store.set( "settings", json )
  }
}

const settingStore = new SettingStore()
window[ "settingStore" ] = settingStore



export default settingStore




// WEBPACK FOOTER //
// ./src/theme/demo2025/stores/settingStore.js